<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <b-row class="justify-content-center">
            <b-col md="7" class="mt-3" v-if="auftrag.id !== 'testid'">
                <b-card-group>
                    <b-card id="auftrag1" ref="el">
                        <div slot="header"
                              style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;">
                            Aufgabe von: <strong>{{auftrag.sachbearbeiter}}</strong>
                        </div>
                        <b-row style="border-bottom: 1px solid #ccc!important;">
                            <b-col sm="6">
                                <b-form-group
                                        label="Auftraggeber:"
                                        label-for="auftraggeber"
                                >
                                    <b-form-input
                                            style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; color: black !important;"
                                            disabled
                                            id="auftraggeber"
                                            type="text"
                                            :placeholder="auftrag.auftraggeber"
                                            v-model="auftrag.auftraggeber"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group
                                        label="Zieltermin an/bis:"
                                        label-for="date"
                                >
                                    <datetime
                                            style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                                            :disabled="isEditMode"
                                            v-model="auftrag.ziel_datum"
                                            input-class="form-control"
                                            input-style="color: black;"
                                            input-id="date"
                                            :aria-placeholder="formateDate"
                                            :phrases="datetimeConfig.phrases"
                                            :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                                            :min-datetime="datetimeConfig.minTime"></datetime>

                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="mt-3">
                            <b-col sm="2">
                                <p class="p-center">Auftragstitle:</p>
                            </b-col>
                            <b-col>
                                <b-form-input
                                        style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                                        class="bold-text"
                                        :disabled="true"
                                        type="text"
                                        v-model="auftrag.gi_auf_ext"
                                        :placeholder="auftrag.gi_auf_ext"
                                >
                                </b-form-input>
                            </b-col>
                        </b-row>
                        <b-row v-if="hasContact">
                            <b-col sm="2">
                                <p class="p-center">Für Rückfragen:</p>
                            </b-col>
                            <b-col>
                                <b-form-textarea
                                        class="text-black"
                                        style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; color: black !important;"
                                        disabled
                                        type="text"
                                        v-model="contact"
                                        :placeholder="contact"
                                        wrap="hard"
                                        rows="3"
                                        :max-rows="maxrows"
                                >
                                </b-form-textarea>
                            </b-col>
                        </b-row>
                        <b-row class="mt-3">
                            <b-col sm="2"></b-col>
                            <b-col>
                                <b-form-textarea id="info-box" ref="infoBox"
                                                 class="text-black"
                                                 style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; color: black !important;"
                                                 :placeholder="auftrag.gi_memo"
                                                 :rows="(auftrag.art !== 'AF' && auftrag.art !== 'DE') ? 4 : 8"
                                                 :max-rows="maxrows"
                                                 wrap="hard"
                                                 :disabled="isEditMode"
                                                 v-model="auftrag.gi_memo"

                                ></b-form-textarea>
                            </b-col>
                        </b-row>
                        <b-row class="mt-3">
                            <b-col sm="2">
                                <p class="p-center">Datum:</p>
                            </b-col>
                            <b-col>
                                <b-form-input
                                        style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                                        disabled
                                        type="text"
                                        v-model="formateDate"
                                        :placeholder="formateDate"
                                >
                                </b-form-input>
                            </b-col>

                            <b-col sm="2">
                                <p class="p-center">Unterschrift:</p>
                            </b-col>
                            <b-col>
                                <b-form-input
                                        style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                                        disabled
                                        type="text"
                                        v-model="auftrag.sachbearbeiter"
                                        :placeholder="auftrag.sachbearbeiter"
                                >
                                </b-form-input>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-card-group>
            </b-col>
            <b-col md="5" class="mt-3" v-if="auftrag.id !== 'testid'">
                <b-card>
                    <b-row style="gap: 10px">
                        <b-button v-if="auftrag.offen === 0" variant="warning" class="btn-pill font-lg" v-on:click="sendToBauhof">
                          An Bauhof senden
                        </b-button>
                            <b-button v-if="auftrag.offen === 0" variant="success" class="btn-pill font-lg" v-on:click="showFinish = true">
                                Fertigstellen
                            </b-button>
                            <b-button v-if="auftrag.offen !== 0" variant="success" class="btn-pill font-lg" disabled>
                                Fertiggestellt
                            </b-button>
                            <b-button variant="primary" class="btn-pill font-lg" v-on:click="back">
                                &nbsp;Zurück
                            </b-button>
                    </b-row>
                </b-card>
                <b-card>
                    <div slot="header">
                        Anhänge
                    </div>
                    <b-row>
                        <b-col>
                            <b-list-group>
                                <b-list-group-item
                                        button
                                        class="d-flex justify-content-between align-items-center"
                                        v-for="item in attachments"
                                        v-on:click="onAttachment(item.file_name, item.data_id, item.file_type)">
                                    {{item.file_name}}
                                    <b-badge class="pt-1 pb-1 pl-2 pr-2" variant="primary" pill>
                                        {{formatBytes(item.file_size)}}
                                    </b-badge>
                                </b-list-group-item>
                            </b-list-group>
                        </b-col>
                    </b-row>
                </b-card>
                <b-card v-if="auftrag.notiz_annahme !== null && auftrag.quittung === 'True'">
                    <div slot="header">
                        Annahme-Nachricht
                    </div>
                    <b-row>
                        <b-col>
                            <b-form-textarea
                                    class="text-black"
                                    :placeholder="annahmeMessage"
                                    rows="6"
                                    max-rows="40"
                                    wrap="hard"
                                    :disabled="true"
                                    v-model="annahmeMessage"

                            ></b-form-textarea>
                        </b-col>
                    </b-row>
                </b-card>
                <b-card v-if="auftrag.notiz_fertig !== null && auftrag.offen >= 1">
                    <div slot="header">
                        Fertigstellungs-Nachricht
                    </div>
                    <b-row>
                        <b-col>
                            <b-form-textarea
                                    class="text-black"
                                    :placeholder="fertigMessage"
                                    rows="6"
                                    max-rows="40"
                                    wrap="hard"
                                    :disabled="true"
                                    v-model="fertigMessage"

                            ></b-form-textarea>
                        </b-col>
                    </b-row>
                </b-card>
                <b-card v-if="auftrag.lat !== 0.0 && auftrag.lon !== 0.0">
                    <div slot="header">
                        Position
                    </div>
                    <b-row style="margin-bottom: 0">
                        <b-col style="height: 250px; padding: 0; margin-bottom: 0" id="map_container"
                               ref="map_container">
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <beautiful-chat
                v-if="hasChat"
                :participants="participants"
                :onMessageWasSent="onMessageWasSent"
                :messageList="messageList"
                :newMessagesCount="newMessagesCount"
                :isOpen="isChatOpen"
                :close="closeChat"
                :open="openChat"
                :showEmoji="false"
                :showFile="true"
                :showTypingIndicator="showTypingIndicator"
                :showLauncher="true"
                :showCloseButton="true"
                :colors="colors"
                :alwaysScrollToBottom="alwaysScrollToBottom"
                :messageStyling="messageStyling"
                :disable-user-input="disableChat"
                :placeholder="messagePlaceholder"
                @file_clicked="onFileClicked"
        >
          <template v-slot:header>
          <div class="sc-header--title ">
            Nachrichten:
          </div>
          </template>
            <!--template v-slot:header>
                <p style="margin: auto; text-align: center; font-weight: bold">Teilnehmer:
                    <span style="font-weight: normal">{{participants.map(m=>m.name).join(', ')}}</span>
                </p>
                <account-multiple-plus-icon class="icon-2x" fillColor="#ac121b" style="color: white;
    align-self: center;
    margin-right: 10px;
    margin-left: 10px;
    box-sizing: border-box;
    cursor: pointer;
    border-radius: 5px;" :size="40" v-on:click="onAddUsers" @file_clicked=""></account-multiple-plus-icon>

            </template-->
            <template v-slot:user-avatar="{ message, user }">
                <div>
                </div>
            </template>
            <template v-slot:text-message-body="{ message }">
                <p style='font-weight: bold; margin-bottom: 3px; font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; margin-left: -12px'>
                    {{message.data.meta_name}}:
                </p>
                <p style="margin-left: -12px; margin-bottom: 8px; white-space: pre-wrap;">{{message.data.text}}</p>
                <p style="text-align: right; font-weight: lighter; font-size: 12px; margin-bottom: 0px; margin-top: 8px; margin-right: -12px">
                    {{message.data.meta}}
                </p>
            </template>
            <template v-slot:text-message-toolbox="{ message }">
            </template>
        </beautiful-chat>
        <b-modal size="sm" v-model="showUserList" id="modal-center" centered title="Nutzer einladen"
                 body-class="my-body" @ok="onAddUserToChat">
            <b-table striped bordered hover responsive id="my-table" :items="userList"
                     :fields="userFields" class="mb-0" selectable thead-class="hidden_header"
                     selectedVariant="success"
                     @row-selected="onUserSelect"
                     select-mode="single"
            >
            </b-table>
            <template #modal-footer="{ok, cancel}">
                <!-- Emulate built in modal footer ok and cancel button actions -->
                <b-button size="md" variant="primary" @click="cancel()">
                    Abbrechen
                </b-button>
                <b-button size="md" variant="success" @click="ok()">
                    Einladen
                </b-button>
            </template>
        </b-modal>
        <b-modal size="sm" v-model="showFinish" id="modal-center" centered title="Aufgabe fertigstellen"
                 body-class="my-body" @ok="finishAufgabe">
            <form>
                <b-form-textarea
                        class="text-black"
                        placeholder="Fertigstellungsnachricht"
                        rows="6"
                        max-rows="40"
                        wrap="hard"
                        v-model="finishMessage"
                        style="min-height: 150px"

                ></b-form-textarea>
            </form>
            <template #modal-footer="{ok, cancel}">
                <!-- Emulate built in modal footer ok and cancel button actions -->
                <b-button size="md" variant="primary" @click="cancel()">
                    Abbrechen
                </b-button>
                <b-button size="md" variant="success" @click="ok()">
                    Fertigstellen
                </b-button>
            </template>
        </b-modal>
        <a ref="show_file" style="display: none;" :href="url" :download="download" target="_blank"></a>
    </div>
</template>

<script>
    import {DateTime as LuxonDateTime} from 'luxon'
    import {Redirect_500, Redirect_Login, Server_URL} from "../../../shared/utils";
    import {decryptAES, decryptFile, decryptMessages, encryptAES, encryptFile} from "../../../shared/crypto";
    import AccountMultiplePlusIcon from 'vue-material-design-icons/AccountMultiplePlus.vue';
    import ZoomControl from 'mapbox-gl-controls/lib/zoom';
    import LanguageControl from 'mapbox-gl-controls/lib/language';
    import mapboxgl from 'mapbox-gl/dist/mapbox-gl';


    export default {
        name: "auftrag",
        components: {
            AccountMultiplePlusIcon
        },
        computed: {
            isEditMode() {
                return !this.editMode;
            },
            a_nr() {
                let base = this.auftrag.gi_augr + " / " + this.auftrag.gi_aufisn;
                if (this.auftrag.art === "DE") {
                    return base;
                }
                return base + (this.auftrag.notiz_annahme !== null && this.auftrag.notiz_annahme !== "" ? " (" + this.auftrag.notiz_annahme + ")" : "");
            },
            formateDate() {
                if (this.auftrag.datum === null) {
                    return ""
                }
                let event = new Date(this.auftrag.datum.replace('Z', ''));
                let options = {year: 'numeric', month: '2-digit', day: '2-digit'};
                return event.toLocaleDateString('de-DE', options);
            }
        },
        props:{
            onFileClicked: {
                type: Function,
                default: undefined
            },
            onFileOk: {
                type: Function,
                default: undefined
            },
            onAttachment: {
                type: Function,
                default: undefined
            },
            responseError: {
                type: Function,
                default: undefined
            },
            showLoader: {
                type: Function,
                default: undefined
            },
            hideLoader: {
                type: Function,
                default: undefined
            },
        },
        data: () => {
            return {
                auftrag: {
                    id: "testid",
                    a_nehmer: "Bauhof",
                    auftraggeber: "Musterhausen-Public Solutions",
                    ziel: "26.01.2019",
                    ziel_datum: LuxonDateTime.fromJSDate(new Date()).toISO(),
                    gi_hh_aus: "9300300.55511010.2-85500",
                    beleg_ex: "2019-0001",
                    gi_auf_ext: "Test Sven",
                    gi_match: "Forstwirtschaft",
                    gi_augr: "0009",
                    gi_aufisn: "000038",
                    gi_memo: "Test vom Sven",
                    email: "info@publicsolutions.de",
                    datum: "",
                    sachbearbeiter: "Administrator",
                },
                deleteMessage: "",
                fertigMessage: "",
                annahmeMessage: "",
                loader: undefined,
                attachments: [],
                bills: [],
                datetimeConfig: {phrases: {ok: 'Ok', cancel: 'Abbruch'}, minTime: LuxonDateTime.local().toISO()},
                maxrows: 40,
                editMode: false,
                textBackup: undefined,
                dateBackup: undefined,
                delete_modal: false,
                freigabe: false,
                deletable: false,
                userId: "",

                interval: null,


                // chat specific
                hasChat: false,
                disableChat: false,
                messagePlaceholder: "Nachricht schreiben...",
                participants: [], // the list of all the participant of the conversation. `name` is the user name, `id` is used to establish the author of a message, `imageUrl` is supposed to be the user avatar.
                messageList: [], // the list of the messages to show, can be paginated and adjusted dynamically
                newMessagesCount: 0,
                isChatOpen: false, // to determine whether the chat window should be open or closed
                showTypingIndicator: '', // when set to a value matching the participant.id it shows the typing indicator for the specific user
                colors: {
                    header: {
                        bg: '#4e8cff',
                        text: '#ffffff'
                    },
                    launcher: {
                        bg: '#4e8cff'
                    },
                    messageList: {
                        bg: '#ffffff'
                    },
                    sentMessage: {
                        bg: '#4e8cff',
                        text: '#ffffff'
                    },
                    receivedMessage: {
                        bg: '#eaeaea',
                        text: '#222222'
                    },
                    userInput: {
                        bg: '#f4f7f9',
                        text: '#565867'
                    }
                }, // specifies the color scheme for the component
                alwaysScrollToBottom: true, // when set to true always scrolls the chat to the bottom when new events are in (new message, user starts typing...)
                messageStyling: false, // enables *bold* /emph/ _underline_ and such (more info at github.com/mattezza/msgdown)
                showUserList: false,
                userList: [],
                userFields: [{
                    key: 'full_name', label: 'Name', formatter: (value, key, item) => {
                        if (item === null) {
                            return null;
                        }
                        let res = JSON.parse(sessionStorage.getItem(item.id));
                        if (res === null) {
                            return value;
                        }
                        return res.full_name;
                    }
                },],
                selectedUsers: [],
                url: "",
                download: "",
                filename: "",
                denyMessage: "Ihre Mängelmeldung wurde von Ihrer Kommune abgelehnt.",
                showDeny: false,
                finishMessage: "Ihre Kommune meldet, dass der von Ihnen gemeldete Mangel nun behoben ist.\nVielen Dank für Ihre Mithilfe.",
                showFinish: false,
                showAccept: false,
                showAcceptMessage: false,
                acceptMessage: "Ihre Mängelmeldung wird nun bearbeitet.\nSobald der Mangel behoben wurde wird Ihnen eine Fertigstellungsmeldung zugesandt.",
                acceptSelf: true,
                acceptOther: false,
                a_select: [],
                an_select: [{text: "Bauhof", value: "Bauhof"}],
                a_nehmer: "Bauhof",
                a_geber: null,
                groups: [],
                hasContact: false,
                contact: "",
                allGroups: {},
            }
        },
        beforeDestroy: function () {
            window.clearInterval(this.interval);
        },
        methods: {
            print() {
                this.$htmlToPaper('auftrag1', () => {
                });
            },

            responseOkFetch(response) {
                if (response.status === 200 && response.body.status === "ok") {
                    this.userId = response.body.session.id;
                    let data = response.body.data;
                    if (sessionStorage.getItem("aes") !== null) {
                        this.decryptData(data.data.gi_memo, data.data.notiz_annahme, data.data.notiz_fertig, data.data.art).then(res => {
                            data.data.gi_memo = res[0];
                            data.data.notiz_annahme = res[1];
                            data.data.notiz_fertig = res[2];
                            this.setData(data);
                        }).catch(e => {
                            this.setData(data);
                        });
                    } else {
                        this.setData(data);
                    }
                } else {
                    this.hideLoader();
                    window.location = Redirect_500;
                }
            },
            async decryptData(memo, annahme, fertig, art) {
                try {
                    if (memo !== null && memo !== "") {
                        memo = await decryptAES(sessionStorage.getItem("aes"), memo);
                    }
                } catch (e) {
                }
                try {
                    if (annahme !== null && annahme !== "" && art === "DE") {
                        annahme = await decryptAES(sessionStorage.getItem("aes"), annahme);
                    }
                } catch (e) {
                }
                try {
                    if (fertig !== null && fertig !== "") {
                        fertig = await decryptAES(sessionStorage.getItem("aes"), fertig);
                    }
                } catch (e) {
                }
                return [memo, annahme, fertig]
            },
            setData(data) {
                this.auftrag = data.data;
                this.allGroups = data.all_groups;
                this.hideLoader();
                this.groups = data.groups;
                for (let i = 0; i < this.groups.length; i++) {
                    let res = JSON.parse(sessionStorage.getItem(this.groups[i].name));
                    if (res !== null) {
                        this.a_select.push({text: res.username, value: this.groups[i]});
                    } else {
                        this.a_select.push({text: this.groups[i].name, value: this.groups[i]});
                    }
                }
                this.contact = "";
                if (this.auftrag.modul === "mm") {
                    let defectData = JSON.parse(this.auftrag.custom_properties);
                    let hasContact = defectData.name !== "" || defectData.email !== "" || defectData.phone_number !== "";
                    if (hasContact) {
                        if (defectData.name !== "") {
                            this.contact += "Name: " + defectData.name + "\n"
                        }
                        if (defectData.email !== "") {
                            this.contact += "Email: " + defectData.email + "\n"
                        }
                        if (defectData.phone_number !== "") {
                            this.contact += "Tel: " + defectData.phone_number + "\n"
                        }
                    }
                }
                this.hasContact = this.contact !== "";
                this.a_geber = this.groups[0];
                if (this.auftrag.modul === "mm" && this.auftrag.art === "AF") {
                    this.auftrag.a_nehmer = "Mängelmelder"
                }
                if (this.auftrag.modul === "mm" && this.auftrag.art === "AU" && this.auftrag.a_nehmer !== "Bauhof" && this.auftrag.auftraggeber === "") {
                    this.auftrag.auftraggeber = "Mängelmelder"
                }
                if (this.auftrag.art === "AF") {
                    this.editMode = true;
                } else {
                    this.editMode = false;
                }
                if (this.auftrag.art === "DE" || this.auftrag.art === 'DN') {
                    this.disableChat = true;
                    this.deleteMessage = this.auftrag.notiz_annahme;
                    this.messagePlaceholder = "Der Auftrag ist abgelehnt."
                }
                if (this.auftrag.offen >= 1) {
                    this.disableChat = true;
                    this.messagePlaceholder = "Der Auftrag ist abgeschlossen."
                }
                if (this.auftrag.notiz_fertig !== null && this.auftrag.notiz_fertig !== "") {
                    this.fertigMessage = this.auftrag.notiz_fertig;
                }
                if (this.auftrag.notiz_annahme !== null && this.auftrag.notiz_annahme !== "") {
                    this.annahmeMessage = this.auftrag.notiz_annahme;
                }
                let res = JSON.parse(sessionStorage.getItem(this.auftrag.auftraggeber));
                if (res !== null) {
                    this.auftrag.auftraggeber = res.username;
                }
                if (this.auftrag.auftraggeber in this.allGroups) {
                    this.auftrag.auftraggeber = this.allGroups[this.auftrag.auftraggeber];
                }

                res = JSON.parse(sessionStorage.getItem(this.auftrag.sachbearbeiter));
                if (res !== null) {
                    this.auftrag.sachbearbeiter = res.first_name + " " + res.surname;
                    this.auftrag.email = res.email;
                }
                this.$nextTick(() => {
                    this.showMapIfNeeded();
                });
                this.attachments = data.attachments;
                this.bills = data.rechnungen;
                this.deletable = data.settings.use_delete;
                if (data.settings.fg_stufe1 && this.auftrag.art === "FG" && this.auftrag.freigabe1 === "-") {
                    this.freigabe = data.user_settings.do_freigabe || this.auftrag.freigeber === data.user_settings.login;
                }
                this.hasChat = data.has_chat && this.auftrag.art !== "SO";

                if (this.hasChat) {
                    for (let i = 0; i < data.authors.length; i++) {
                        let res = JSON.parse(sessionStorage.getItem(data.authors[i].id));
                        if (res !== null) {
                            data.authors[i].name = res.full_name;
                        }
                    }
                    this.participants = data.authors;
                    if (sessionStorage.getItem("aes") !== null) {
                        decryptMessages(sessionStorage.getItem("aes"), data.messages).then(res => {
                            this.messageList = res;
                            if (this.messageList.length !== 0) {
                                this.isChatOpen = true;
                            }
                            if (this.interval === null) {
                                this.interval = setInterval(this.refresh, 2000);
                            }
                        }).catch(err => {
                            this.messageList = data.messages;
                            if (this.messageList.length !== 0) {
                                this.isChatOpen = true;
                            }
                            if (this.interval === null) {
                                this.interval = setInterval(this.refresh, 2000);
                            }
                        })
                    } else {
                        this.messageList = data.messages;
                        if (this.messageList.length !== 0) {
                            this.isChatOpen = true;
                        }
                        if (this.interval === null) {
                            this.interval = setInterval(this.refresh, 2000);
                        }
                    }
                }
            },
          sendToBauhof() {
            this.$router.push("/create?data_id=" + this.$route.params.id);
          },
            formatBytes(bytes, decimals = 2) {
                if (bytes === 0) return '0 Bytes';

                const k = 1024;
                const dm = decimals < 0 ? 0 : decimals;
                const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

                const i = Math.floor(Math.log(bytes) / Math.log(k));

                return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
            },
            back() {
                window.history.back();
            },
            openChat() {
                // called when the user clicks on the fab button to open the chat
                this.isChatOpen = true
                this.newMessagesCount = 0
            },
            closeChat() {
                // called when the user clicks on the botton to close the chat
                this.isChatOpen = false
            },
            onMessageWasSent(message) {
                // called when the user sends a message
                if (this.interval !== null) {
                    clearInterval(this.interval);
                    this.interval = null;
                }
                if (message.type === "text") {
                    let body = {
                        data_id: this.auftrag.id,
                        data_beleg_ex: this.auftrag.beleg_ex,
                        message: message.data.text,
                    };
                    if (this.messageList.length > 0) {
                        body.create_date = this.messageList[this.messageList.length - 1].data.meta_date;
                    }
                    if (sessionStorage.getItem("aes") !== null) {
                        encryptAES(sessionStorage.getItem("aes"), body.message).then(res => {
                            body.plain_text = body.message;
                            body.plain_name = JSON.parse(sessionStorage.getItem(this.userId)).full_name;
                            body.message = res;
                            this.$http.post(
                                Server_URL + '/auftragsbuch/data/message', body
                            ).then(this.onNewMessages, this.responseError)
                        })
                    } else {
                        this.$http.post(
                            Server_URL + '/auftragsbuch/data/message', body
                        ).then(this.onNewMessages, this.responseError)
                    }
                } else {
                    if (sessionStorage.getItem("aes") !== null) {
                        this.showLoader();
                        const reader = new FileReader();
                        reader.addEventListener('load', (event) => {
                            let buf = new Uint8Array(event.target.result);
                            encryptFile(sessionStorage.getItem("aes"), buf).then(res => {
                                const b = new Blob([res], {type: message.data.file.type});
                                let lastDate = "";
                                if (this.messageList.length > 0) {
                                    lastDate = this.messageList[this.messageList.length - 1].data.meta_date;
                                }
                                let formData = new FormData();
                                formData.append('upload_file', b, message.data.file.name);
                                this.$http.post( Server_URL+'/auftragsbuch/data/file_message/'
                                    +this.$route.params.id+"?plain_name=" + JSON.parse(sessionStorage.getItem(this.userId)).full_name + "&last_date=" + lastDate,
                                    formData,
                                    {
                                        headers: {
                                            'Content-Type': 'multipart/form-data'
                                        }
                                    }
                                ).then(this.onNewMessages, this.responseError)
                            }).catch(err => {
                                this.hideLoader();
                            })
                        });
                        reader.readAsArrayBuffer(message.data.file);
                    } else {
                        let lastDate = "";
                        if (this.messageList.length > 0) {
                            lastDate = this.messageList[this.messageList.length - 1].data.meta_date;
                        }
                        let formData = new FormData();
                        formData.append('upload_file',message.data.file);
                        this.$http.post( Server_URL+'/auftragsbuch/data/file_message/'
                            +this.$route.params.id+"?plain_name=xxx"+"&last_date=" + lastDate,
                            formData,
                            {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            }
                        ).then(this.onNewMessages, this.responseError)
                    }
                }
            },
            onNewMessages(response) {
                if (response.status === 200) {
                    if (response.body.authors !== undefined) {
                        for (let i = 0; i < response.body.authors.length; i++) {
                            let found = false;
                            for (let j = 0; j < this.participants.length; j++) {
                                if (this.participants[j].id === response.body.authors[i].id) {
                                    found = true;
                                    break
                                }
                            }
                            if (!found) {
                                let res = JSON.parse(sessionStorage.getItem(response.body.authors[i].id));
                                if (res !== null) {
                                    response.body.authors[i].name = res.full_name;
                                }
                                this.participants.push(response.body.authors[i]);
                            }
                        }
                    }
                    if (sessionStorage.getItem("aes") !== null) {
                        decryptMessages(sessionStorage.getItem("aes"), response.body.messages).then(res => {
                            for (let i = 0; i < res.length; i++) {
                                this.messageList.push(res[i]);
                            }
                            this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + res.length;
                            if (this.interval === null) {
                                this.interval = setInterval(this.refresh, 2000);
                            }
                        })
                    } else {
                        for (let i = 0; i < response.body.messages.length; i++) {
                            this.messageList.push(response.body.messages[i]);
                        }
                        this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + response.body.messages.length;
                        if (this.interval === null) {
                            this.interval = setInterval(this.refresh, 2000);
                        }
                    }
                    this.hideLoader();
                } else {
                    this.hideLoader();
                    window.location = Redirect_500;
                }
            },
            refresh() {
                let url = Server_URL + '/auftragsbuch/data/messages/' + this.auftrag.id;
                if (this.messageList.length !== 0) {
                    url += "?last_date=" + encodeURIComponent(this.messageList[this.messageList.length - 1].data.meta_date);
                }
                this.$http.get(
                    url
                ).then(this.onNewMessages, this.responseErrorTrap)
            },
          responseErrorTrap(response) {
            if (response.status === 401) {
              window.location = Redirect_Login;
            } else {
              console.log(response);
            }
          },
            onAddUsers() {
                this.showUserList = true;
                this.selectedUsers = [];
                this.showLoader();
                this.$http.get(
                    Server_URL + '/auftragsbuch/data/users'
                ).then(this.responseOkFetchUsers, this.responseError)
            },
            responseOkFetchUsers(response) {
                if (response.status === 200) {
                    this.hideLoader();
                    let users = [];
                    for (let i = 0; i < response.body.length; i++) {
                        let found = false;
                        for (let j = 0; j < this.participants.length; j++) {
                            if (response.body[i].id === this.participants[j].id) {
                                found = true;
                                break;
                            }
                        }
                        if (!found) {
                            users.push(response.body[i]);
                        }
                    }
                    this.userList = users;
                } else {
                    this.hideLoader();
                    window.location = Redirect_500;
                }
            },
            onUserSelect(items) {
                this.selectedUsers = items;
            },
            onAddUserToChat() {
                if (this.selectedUsers.length === 0) {
                    return
                }
                let payload = {};
                if (sessionStorage.getItem("aes") !== null) {
                    payload = {
                        data_id: this.auftrag.id,
                        plain_name: JSON.parse(sessionStorage.getItem(this.userId)).full_name,
                        recipient_id: this.selectedUsers[0].id,
                        recipient_plain_name: JSON.parse(sessionStorage.getItem(this.selectedUsers[0].id)).full_name,
                    }
                } else {
                    payload = {
                        data_id: this.auftrag.id,
                        recipient_id: this.selectedUsers[0].id,
                        recipient_plain_name: this.selectedUsers[0].full_name,
                    }
                }
                this.showLoader();
                this.$http.post(
                    Server_URL + '/auftragsbuch/data/message/invite', payload
                ).then(this.responseOkInvite, this.responseError)
            },
            responseOkInvite(response) {
                if (response.status === 200) {
                    this.hideLoader();
                    this.participants.push(response.body);
                } else {
                    this.hideLoader();
                    window.location = Redirect_500;
                }
            },
            responseOkReload() {
                this.$http.get(
                    Server_URL + '/auftragsbuch/data/single/' + this.$route.params.id
                ).then(this.responseOkFetch, this.responseError)
            },
            showMapIfNeeded() {

                if (this.map !== undefined || this.auftrag.lat === 0.0 || this.auftrag.lon === 0.0) {
                    return;
                }

                mapboxgl.accessToken = 'pk.eyJ1Ijoic3ZlbnBldGVyc2VuIiwiYSI6ImNqc3Z0YW82dDBhbDE0NXFpOGRzOXI4NWsifQ.Sq1nJiC3uKfA5yfYN8wR9w';
                this.map = new mapboxgl.Map({
                    container: 'map_container',
                    style: 'mapbox://styles/mapbox/outdoors-v11',
                    center: [this.auftrag.lon, this.auftrag.lat],
                    zoom: 18,
                    minZoom: 5,
                    maxPitch: 0,
                    attributionControl: false
                });

                this.map.addControl(new ZoomControl(), 'bottom-right');
                const languageControl = new LanguageControl({
                    language: 'de',
                });
                this.map.addControl(languageControl);

                this.map.addControl(new mapboxgl.AttributionControl(), "top-right");

                this.marker = null;
                this.geojson = {};
                this.map.on('load', this.mapLoad);
            },
            mapLoad() {
                setTimeout(() => {
                    if (this.marker === null) {
                        let el = document.createElement('div');
                        el.className = 'marker';

                        this.marker = new mapboxgl.Marker({
                            element: el,
                            anchor: 'center',
                        })
                            .setLngLat([this.auftrag.lon, this.auftrag.lat])
                            .addTo(this.map);
                    }
                    this.map.resize();
                    this.hideLoader()
                });
            },
            changeSelf(val) {
                this.acceptOther = !val;
            },
            changeOther(val) {
                this.acceptSelf = !val;
            },
            finishAufgabe() {
                this.showLoader();
                let payload ={
                    finish_message: this.finishMessage
                };
                this.$http.post(
                    Server_URL + '/auftragsbuch/data/finish/'+ this.auftrag.id, payload
                ).then(this.responseOkReload, this.responseError)
            }
        },
        created() {
            this.showLoader();
            this.$http.get(
                Server_URL + '/auftragsbuch/data/single/' + this.$route.params.id
            ).then(this.responseOkFetch, this.responseError)
        },

    }
</script>

<style>

    .marker {
        background-image: url('../../../../public/mangel_marker.png');
        background-size: cover;
        width: 35px;
        height: 35px;
        border-radius: 50%;
        cursor: pointer;
        z-index: 1;
    }

    .sc-message {
        width: 480px;
    }

    .sc-message--text .sc-message--toolbox {
        display: none;
    }

    .sc-launcher.opened :before {
        box-shadow: none;
    }

    .sc-launcher.opened:before {
        box-shadow: none !important;
    }

    .sc-chat-window {
        border: 1px solid lightgray !important;
        width: 520px !important;
      z-index: 5;
    }

    .sc-launcher {
      z-index: 5;
    }

    .sc-user-input {
        border-top: 1px solid lightgray !important;

    }

    .sc-user-input--text {
        width: 450px !important;
    }

    .sc-header--close-button {
        margin-left: 0 !important;
    }

    .my-body {
        padding: 0 !important;
    }

    .hidden_header {
        display: none;
    }

    .sc-user-input--file-icon-wrapper {
        margin-bottom: 0;
    }
    .sc-header {
      min-height: unset !important;
    }
</style>

<style scoped>

    .form-control:disabled, .form-control[disabled] {
        color: black !important;
    }

    .text-black {
        color: black;
    }

    .p-center {
        height: calc(1.5em + 0.75rem + 2px);
        padding: 0.375rem 0;
    }

    .bold-text {
        font-weight: bold;
    }

    ::placeholder { /* Firefox, Chrome, Opera */
        color: black;
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: black;
    }

    ::-ms-input-placeholder { /* Microsoft Edge */
        color: black;
    }

</style>
